import { useCheckPreferences } from "./hooks/useCheckPreferences";
import { useCheckExternalMessages } from "./hooks/useCheckExternalMessages";
import { useWindowHistoryByMouse } from "./hooks/useWindowHistoryByMouse";
import { useHideAllMenus } from "./hooks/useHideAllMenus";
import { useGeoBlockedPage } from "./hooks/useGeoBlockedPage";
import { useTrackPWA } from "./hooks/useTrackPWA";
import { useResetSearchTag } from "./hooks/useResetSearchTag";
import { useHeaderScroll } from "./hooks/useHeaderScroll";
import { useDetectGeolocation } from "@/common/hooks/useDetectGeolocation";
import { useTrackCookieConsent } from "@/common/hooks/useTrackCookieConsent";
import { useGoCtrl } from "./hooks/useGoCtrl";
import { useAppStyles } from "@/common/hooks/useAppStyles";
import { useGetUserData } from "@/common/hooks/useGetUserData";
import { useInitDocumentTitle } from "@/common/hooks/useInitDocumentTitle";
import { useTrackVisit } from "@/common/hooks/useTrackVisit";
import { useFullScreen } from "@/common/hooks/useFullScreen";
import { useTrackUser } from "@/common/hooks/useTrackUser";
import { useOrientation } from "@/common/hooks/useOrientation";
import { useScroll } from "@/common/hooks/useScroll";
import { useGTM } from "@/common/hooks/useGTM";
import { useCensor } from "./hooks/useCensor";
import { useVerification } from "components/app/AppHooks/hooks/useVerification";
import { useFeedModules } from "./hooks/useFeedModules";
import { useAgeDisclaimer } from "@/common/hooks/useAgeDisclaimer";

export const AppHooks = () => {
  useGetUserData();
  useCheckPreferences();
  useCheckExternalMessages();
  useDetectGeolocation();
  useGeoBlockedPage();
  useAgeDisclaimer();

  useTrackVisit();
  useAppStyles();
  useWindowHistoryByMouse();
  useInitDocumentTitle();
  useHideAllMenus();
  useFullScreen();
  useTrackUser();
  useOrientation();
  useTrackPWA();
  useResetSearchTag();

  useHeaderScroll();
  useScroll();

  useTrackCookieConsent();
  useGoCtrl();
  useGTM();

  useCensor();
  useVerification();

  useFeedModules();

  return null;
};
